(()=>{
  if(customElements.get('awa-installation-checker'))return;
  const controllers=new Map(),storageKey='awa_postcode_v1',storageVersion=1;
  const postcodeStates=[['ACT',[['0200','0299'],['2600','2619'],['2900','2920']]],['NT',[['0800','0999']]],['NSW',[['1000','2599'],['2620','2899'],['2921','2999']]],['VIC',[['3000','3999'],['8000','8999']]],['QLD',[['4000','4999'],['9000','9999']]],['SA',[['5000','5999']]],['WA',[['6000','6999']]],['TAS',[['7000','7999']]]];
  const crossBorderStates={'0872':'NT','2406':'NSW','2611':'ACT','2620':'NSW','3644':'VIC','3691':'VIC','3707':'VIC','4825':'QLD'};
  const stateFor=postcode=>crossBorderStates[postcode]||postcodeStates.find(([,ranges])=>ranges.some(([start,end])=>postcode>=start&&postcode<=end))?.[0]||'';
  const readFallback=()=>{
    try{
      const value=JSON.parse(localStorage.getItem(storageKey)||'null');
      if(value?.version!==storageVersion||!window.AWAInstallationCoverage.isAustralianPostcode(value.postcode)||Date.parse(value.expiresAt)<=Date.now())return null;
      return value;
    }catch{return null}
  };
  const saveFallback=postcode=>{
    const now=new Date(),value={postcode,state:stateFor(postcode),savedAt:now.toISOString(),expiresAt:new Date(now.getTime()+30*86400000).toISOString(),version:storageVersion};
    try{localStorage.setItem(storageKey,JSON.stringify(value))}catch{}
    window.dispatchEvent(new CustomEvent('awa:postcode:changed',{detail:{postcode:value.postcode,state:value.state,source:'awa-installation-checker'}}));
    return value;
  };
  const getSharedPostcode=()=>window.AWAPostcode?.get?.()||readFallback();
  const setSharedPostcode=postcode=>{
    if(typeof window.AWAPostcode?.set==='function'){
      window.AWAPostcode.set(postcode,{source:'awa-installation-checker'});
      return window.AWAPostcode.get?.()||{postcode};
    }
    return saveFallback(postcode);
  };
  class AWAInstallationChecker extends HTMLElement{
    connectedCallback(){
      if(this.mounted)return;
      this.mounted=true;
      this.abort=new AbortController();
      this.input=this.querySelector('[data-awa-installation-postcode]');
      this.form=this.querySelector('[data-awa-installation-form]');
      this.error=this.querySelector('[data-awa-installation-error]');
      this.result=this.querySelector('[data-awa-installation-result]');
      this.status=this.querySelector('[data-awa-installation-status]');
      this.message=this.querySelector('[data-awa-installation-message]');
      this.scope=this.closest('.product-information--inner')||document;
      try{this.config=JSON.parse(this.querySelector('[data-awa-installation-config]')?.textContent||'{}')}catch{this.config={}}
      this.profile={id:this.config.profileId||'',source:this.config.profileSource||'',enabled:this.config.enabled===true,rules:this.config.rules||''};
      this.profile.parsed=window.AWAInstallationCoverage?.parseRules?.(this.profile.rules);
      if(!this.input||!this.form||!this.profile.parsed?.valid){this.hidden=true;return}
      controllers.set(String(this.config.productId||''),this);
      this.form.addEventListener('submit',event=>{event.preventDefault();this.check(this.input.value,{persist:true})},{signal:this.abort.signal});
      this.input.addEventListener('input',()=>{this.input.value=this.input.value.replace(/\D/g,'').slice(0,4);this.showNeutral()},{signal:this.abort.signal});
      this.scope.addEventListener('click',event=>this.blockUnavailableService(event),{capture:true,signal:this.abort.signal});
      ['awa:postcode:ready','awa:postcode:changed'].forEach(name=>window.addEventListener(name,event=>this.syncPostcode(event.detail),{signal:this.abort.signal}));
      window.addEventListener('awa:postcode:cleared',()=>{this.input.value='';this.showNeutral()},{signal:this.abort.signal});
      document.addEventListener('awa:postcode:updated',event=>this.syncPostcode(event.detail),{signal:this.abort.signal});
      this.observer=new MutationObserver(()=>this.updateInstallationCards());
      this.observer.observe(this.scope,{childList:true,subtree:true});
      const saved=getSharedPostcode();
      if(saved?.postcode)this.syncPostcode(saved);
      else this.showNeutral();
    }
    disconnectedCallback(){
      this.abort?.abort();
      this.observer?.disconnect();
      controllers.delete(String(this.config?.productId||''));
      this.mounted=false;
    }
    syncPostcode(detail){
      const postcode=String(detail?.postcode||'').trim();
      if(!postcode||this.syncing)return;
      this.input.value=postcode;
      this.check(postcode,{persist:false});
    }
    check(raw,{persist=false}={}){
      const postcode=String(raw||'').trim(),decision=window.AWAInstallationCoverage.evaluate(this.profile,postcode);
      if(decision.state==='invalid'){
        this.error.textContent=this.config.copy?.invalid||'Enter a valid 4-digit Australian postcode.';
        this.error.hidden=false;
        this.result.hidden=true;
        this.state='neutral';
        this.updateInstallationCards();
        return decision;
      }
      this.error.hidden=true;
      if(persist){
        this.syncing=true;
        try{setSharedPostcode(postcode)}finally{this.syncing=false}
      }
      this.state=decision.state;
      this.result.hidden=false;
      this.result.classList.toggle('is-available',decision.available===true);
      this.result.classList.toggle('is-unavailable',decision.available===false);
      this.result.querySelector('.awa-installation-checker__icon').textContent=decision.available?'✓':'×';
      this.status.textContent=decision.available?this.config.copy?.availableHeading:this.config.copy?.unavailableHeading;
      const template=decision.available?this.config.copy?.availableMessage:this.config.copy?.unavailableMessage;
      this.message.textContent=String(template||'').replace('[POSTCODE]',postcode);
      this.updateInstallationCards();
      window.dispatchEvent(new CustomEvent('awa:installation-coverage:changed',{detail:{productId:String(this.config.productId||''),postcode,available:decision.available,profileId:this.profile.id,profileSource:this.profile.source}}));
      return decision;
    }
    showNeutral(){
      this.error.hidden=true;
      this.result.hidden=true;
      this.state='neutral';
      this.updateInstallationCards();
    }
    installationCards(){
      return [...this.scope.querySelectorAll('.complementary-products product-card-small[data-installation-service="true"]')];
    }
    updateInstallationCards(){
      const disabled=this.state==='unavailable';
      this.installationCards().forEach(card=>{
        card.classList.toggle('is-installation-unavailable',disabled);
        card.dataset.installationCoverageState=disabled?'unavailable':'available';
        const action=card.querySelector('.product-card-small--add-to-cart-button'),notice=card.querySelector('[data-installation-coverage-notice]');
        if(notice)notice.hidden=!disabled;
        if(!action)return;
        if(disabled){
          if(!action.dataset.awaCoverageDisabled){action.dataset.awaCoverageDisabled='true';action.dataset.awaPreviousTabindex=action.getAttribute('tabindex')||''}
          if('disabled'in action)action.disabled=true;
          action.setAttribute('aria-disabled','true');
          action.setAttribute('tabindex','-1');
        }else if(action.dataset.awaCoverageDisabled){
          if('disabled'in action)action.disabled=false;
          action.removeAttribute('aria-disabled');
          if(action.dataset.awaPreviousTabindex)action.setAttribute('tabindex',action.dataset.awaPreviousTabindex);else action.removeAttribute('tabindex');
          delete action.dataset.awaCoverageDisabled;
          delete action.dataset.awaPreviousTabindex;
        }
      });
    }
    blockUnavailableService(event){
      if(this.state!=='unavailable')return;
      const action=event.target.closest?.('.product-card-small--add-to-cart-button');
      const card=action?.closest('.complementary-products product-card-small[data-installation-service="true"]');
      if(!card)return;
      event.preventDefault();
      event.stopImmediatePropagation();
      card.querySelector('[data-installation-coverage-notice]')?.removeAttribute('hidden');
    }
    validateInstallation(services=[]){
      if(!services.some(service=>service.role==='installation'))return{valid:true,reason:'no_installation_selected'};
      if(this.state==='available')return{valid:true,reason:'eligible'};
      if(this.state==='unavailable')return{valid:false,reason:'outside_coverage',message:this.config.copy?.unavailableHeading};
      return{valid:true,reason:'postcode_not_checked'};
    }
  }
  customElements.define('awa-installation-checker',AWAInstallationChecker);
  const availability=window.AWAProductAvailability||{};
  if(typeof availability.getInstallationValidation!=='function')availability.getInstallationValidation=(productId,services)=>controllers.get(String(productId))?.validateInstallation(services)||{valid:true,reason:'coverage_checker_inactive'};
  window.AWAProductAvailability=availability;
})();
